import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  IconButton,
  Box
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {ReactComponent as WarningImage} from '../../assets/warning.svg';
import { useTheme } from "@mui/material/styles";

const DeleteConfirmationDialog = ({ open, onClose, onConfirm, type, identifierName }: any) => {
  const theme = useTheme();
  const colors = theme.palette;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          backgroundColor: colors.modal.bg,
          color: colors.modal.text,
          width: "600px",
          borderRadius: "8px",
        },
      }}
    >
      {/* Header Section */}
      <DialogTitle
        sx={{
            bgcolor: 'blue.darker',
            color: 'white.main',
            p: 1,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
      >
         <span>
    Deleting {type} <span style={{ fontWeight: "bold" }}>{identifierName}</span>
  </span>
        <IconButton onClick={onClose} sx={{ color: "white.main"}}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      {/* Content Section */}
      <DialogContent
        sx={{
          padding: "20px",
          backgroundColor: colors.modal.bg,
          color: colors.modal.text
        }}
      >
            <Box display="flex" justifyContent="flex-start" gap={1} sx={{mt: 1}}>
                <WarningImage style={{width: 40, height: 40, padding: 8}}/>
                <Box>
                    <Typography
                      variant="h6"
                      sx={{
                        color: colors.modal.text
                      }}
                    >
                        Are you sure to delete this {type}?
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        opacity: 0.8,
                        color: colors.modal.text
                      }}
                    >
                        Once confirmed, the action can't be undone.
                    </Typography>
                </Box>
            </Box>
        </DialogContent>

      {/* Actions Section */}
      <DialogActions
        sx={{
          justifyContent: "flex-end",
          padding: 1,
          backgroundColor: colors.modal.bg
        }}
      >
        <Button
          onClick={onClose}
          sx={{
            color: colors.buttons.primary.textColor,
            textTransform: "uppercase"
          }}
        >
          NO, I WANT IT!
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="error"
          sx={{ textTransform: "uppercase" }}
        >
          DELETE
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationDialog;